module.exports = __webpack_public_path__ + "img/sueco.47b81568.svg";